import { Component, AfterViewInit } from '@angular/core';
import { ListFormBase } from '../../core/helper/ListFormBase';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { ConfiguracionEmpresa } from '../../core/models/configuracionEmpresa.model';
import { ConfiguracionEmpresaService } from '../../core/services/configuracionEmpresa.service';
import { A3LCompanyService } from '../../core/services/a3LCompany.service';
import { A3LCompany } from '../../core/models/a3LCompany.model';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-my-companies-config-list',
  templateUrl: './my-companies-config-list.component.html',
  styleUrls: ['./my-companies-config-list.component.scss'],
  providers: [ConfiguracionEmpresaService, A3LCompanyService]
})
export class MyCompaniesConfigListComponent extends ListFormBase<ConfiguracionEmpresa>
  implements AfterViewInit {
  // Propiedades del panel contenedor
  panelIcon = 'business'; // material icon
  panelTitle = 'Empresas';
  panelDescription = 'Listado de las empresas configuradas';

  companies = new Array<A3LCompany>();

  constructor(
    protected _modelService: ConfiguracionEmpresaService,
    protected _companyService: A3LCompanyService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog
  ) {
    super(_modelService, _router, _route, _messageDialog, ConfiguracionEmpresa);
    this.isCrud = true;
    this.getCompanies();
  }

  ngAfterViewInit(): void {
    this.dataGrid.instance.beginCustomLoading('');
  }

  getCompanies(): void{
    this._companyService.getAllForSelect().subscribe(res => {
      if (res){
        this.companies = res;
      }
      this.dataGrid.instance.endCustomLoading();
    },
    error => {
      console.error(error);
      this._messageDialog.ShowException(error);
      this.dataGrid.instance.endCustomLoading();
    },
    () => this.getDataSource());
  }
}
